export const MAX_HEIGHT = 1000;
